.container {
  padding-bottom: 90px;
}

/* Tap targets on a phone are at least 44 px tall (BUG-19): fields, the consent row, the links. */
.input {
  width: 100%;
  min-height: var(--gac-control-touch-target);
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  /* 16px, not 15: below 16 iOS Safari zooms the page into a focused field, and the viewport no
     longer forbids zoom (BUG-11) — the sheet would stay zoomed and clipped after blur. */
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.input:focus {
  border-color: rgba(204, 255, 0, 0.6);
}

.email {
  color: #ffffff;
  font-weight: 600;
}

.earlyAccess {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(204, 255, 0, 0.35);
  background: rgba(204, 255, 0, 0.06);
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
}

.checkboxRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: var(--gac-control-touch-target);
  gap: 10px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.checkbox {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkboxChecked {
  background: #ccff00;
  border-color: #ccff00;
}

.linkButton {
  background: transparent;
  border: none;
  min-height: var(--gac-control-touch-target);
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

/* The dealer's country and city (api#298): a native select in the field's clothes. `color-scheme`
   keeps the browser's own list dark, like the page. The caret is ours, drawn by the wrapper in
   `text / secondary`: iOS Safari paints none on a styled select, so `appearance: none` takes the
   browser's away everywhere and the icon stands in. Colours are the brand's tokens, not numbers. */
.selectWrap {
  position: relative;
  display: block;
  color: var(--gac-text-secondary);
}

/* The caret dims with the text of a switched-off select — one state, read off the control itself. */
.selectWrap:has(select:disabled) {
  color: var(--gac-text-disabled);
}

.select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 44px;
  color-scheme: dark;
  cursor: pointer;
}

/* Nothing chosen yet: the first option reads as a placeholder (`text / muted`), not as a value. */
.selectPlaceholder {
  color: var(--gac-text-muted);
}

/* The options are values whatever the box shows. The list is dark by `color-scheme`; the background
   is named too, for a browser that styles options but ignores the scheme — white on white otherwise. */
.select option {
  color: var(--gac-text-primary);
  background-color: var(--gac-surface-raised-solid);
}

/* A switched-off control: `text / disabled` is the one place that step is for. */
.select:disabled {
  color: var(--gac-text-disabled);
  cursor: default;
}

.selectCaret {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  pointer-events: none;
}

.inlineLink {
  color: var(--gac-accent);
  text-decoration: underline;
}

/* A link or a button inside a sentence ("write to …", "Try again"): an atomic inline a thumb's height
   (BUG-19), as `.linkButton` is. The line grows around it — a box grown by padding and a negative
   margin would spill over the control above and take its taps. `SF-I3` measures the box. */
.inlineLink,
.inlineButton {
  display: inline-flex;
  align-items: center;
  min-height: var(--gac-control-touch-target);
}

/* A real label: block, so the whole line is the control's handle. */
.label {
  display: block;
  cursor: pointer;
}

/* "Try again" inside an error line: a button that reads as a link. */
.inlineButton {
  background: transparent;
  border: none;
  padding: 0;
  color: var(--gac-accent);
  text-decoration: underline;
  font: inherit;
  cursor: pointer;
}
